<template>
    <!-- 管理员列表 -->
    <div>
        <el-card>
          <el-row :gutter=20>
            <el-col :span="4">
                <el-button type="primary" @click="$refs.AddUser.show()" size="mini">添加管理员</el-button>
            </el-col>
          </el-row>
            <el-table :header-cell-style="{'text-align':'center'}"
                      :cell-style="{'text-align':'center','padding':'0px'}"
                      :data="platformAdminList" border stripe>
                <el-table-column type="index"></el-table-column>
                <el-table-column label="登录名" prop="username"></el-table-column>
                <el-table-column label="姓名" prop="realName"></el-table-column>
                <el-table-column label="手机号" prop="phone"></el-table-column>
                <el-table-column wdith="180px" label="操作">
                  <template slot-scope="scope">
                      <!-- 修改按钮 -->
                      <el-button type="text" icon="el-icon-edit" size="mini" @click="$refs.EditUser.show(scope.row.userId)">修改管理员</el-button>
                      <!-- 删除按钮 -->
                      <el-button type="text" icon="el-icon-delete" size="mini" @click="removeFactoryById(scope.row.userId)">删除管理员</el-button>
                  </template>
                </el-table-column>
            </el-table>
            <!-- 分页区域 -->
          <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pagenum"
          :page-sizes="[5]"
          :page-size="queryInfo.pagesize"
          layout="total, prev, pager, next, jumper"
          :total="total"
         >
          </el-pagination>
        </el-card>
        <add-user ref="AddUser"/>
        <edit-user ref="EditUser"/>
    </div>
</template>
<script>
import * as api from '@/api/platform/admin'
import { AddUser, EditUser } from './components'
export default {
  data () {
       // 验证真实姓名的规则
    var checkRealname = (rules, value, cr) => {
      // 验证真实姓名的正则表达式
      const realnameReg = /^[\u4E00-\u9FA5]{2,10}(·[\u4E00-\u9FA5]{2,10}){0,2}$/
      if (realnameReg.test(value)) {
        return cr()
      }
      cr(new Error('请输入真实姓名'))
    }
    return {
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' },
        { min: 3, max: 10, message: '长度在3 到 10 个字符之间', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' },
        { min: 6, max: 15, message: '长度在6 到 15 个字符之间', trigger: 'blur' }],
        realName: [{ required: true, message: '请输入姓名', trigger: 'blur' },
        { validator: checkRealname, trigger: 'blur' }],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' },
        { validator: this.$valid.checkPhone, trigger: 'blur' }]
      },
      platformAdminList: [],
      queryInfo: {
        // 查询关键字
        query: '',
        // 当前的页数
        pagenum: 1,
        // 当前每页显示的数量
        pagesize: 5
      },
      total: 0
    }
  },
  created () {
    this.getPlatformAdminList()
  },

    // F5刷新时候，beforeMount()会被调用
    beforeMount () {
        // hongmj: 案2: 利用sessionStorage 保存当前页面号，F5刷新时候 能回到当前页面。
        const savedPage = window.sessionStorage.getItem('platform_platformAdmin')

        if (savedPage !== null) {
            // 去刷新页面
            this.queryInfo.pagenum = savedPage
            // this.getPlatformAdminList() 会产生2次请求，禁止写。
        }
    },

  methods: {
    // 获取管理员分页列表
    getPlatformAdminList () {
      const params = {
          page: this.queryInfo.pagenum,
          size: this.queryInfo.pagesize
        }
      api.getPlatformAdminList(params).then(res => {
        this.platformAdminList = res.data.list
        this.total = res.data.total
      })
    },
    // 修改一页展示几个
    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getPlatformAdminList()
    },
    // 分页切换
    handleCurrentChange (newNum) {
      this.queryInfo.pagenum = newNum
      this.getPlatformAdminList()

      // hongmj: 案2: 利用sessionStorage 保存当前页面号，F5刷新时候 能回到当前页面。
      window.sessionStorage.setItem('platform_platformAdmin', newNum)
    },
    // 删除管理员
    removeFactoryById (id) {
      api.removeFactoryById({ userId: id }).then(res => {
        this.$message.success('删除平台管理员成功！')
        this.getPlatformAdminList()
      })
    },
    // 修改管理员
    userStateChanged (userInfo) {
      this.$request2({
        url: `platformAdmin/modifyState/${userInfo.id}`,
        method: 'POST',
        params: { state: userInfo.enable }
      }).then(res => {
        this.$message.success('修改管理员状态成功！')
      })
    }
  },
  components: {
    AddUser,
    EditUser
  }
}
</script>
<style lang="less" scoped>
.el-table {
  margin-top: 15px;
  font-size: 12px;
}

.el-pagination {
  margin-top: 15px;
}

.el-cascader-panel {
  height: 200px;
}
</style>
